import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const LandingPageHeader = styled.div<{ theme: Theme }>`
  display: grid;
  // the header wrapper overflows the page container (1440px) but we want to ensure that its content doesn't
  grid-template-columns: auto min(calc(1440px - (2 * var(--Grid-Margin))), calc(100vw - (2 * var(--Grid-Margin)))) auto;
  gap: 16px 0;
  background: ${getColor('surfaceSecondary')};
  padding: 28px 16px 24px 16px;

  & > * {
    grid-column: 2;
  }

  @media (${breakpoint.mdMin}) {
    background: linear-gradient(263deg, rgba(253, 251, 251, 0.80) 35.75%, #EAEDEE 127.09%); 
    padding: 40px 24px 40px;
  }

  @media (${breakpoint.xxlMin}) {
    background: linear-gradient(267deg, rgba(253, 251, 251, 0.83) -3.58%, #EAEDEE 136.01%);
    padding: 48px 48px;
  }
`;

export const BreadcrumbsContainer = styled.div`
  margin-bottom: 8px;
`;

export const Title = styled(Heading)`
  @media (${breakpoint.xxlMin}) {
    font-size: 60px;
  }
`;

export const AuthorsContainer = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  ${getBodyStyle('graphikCond', { default: 'small' }, 'regular')};
  text-transform: uppercase;
  z-index: 1001;

  @media (${breakpoint.smMin}) {
    gap: 16px;
  }

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
  }
`;

export const LandingPageHeroDate = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' }, 'regular')};
  letter-spacing: 0.15px;
  color: ${getColor('textSecondary')};
`;
